import React from "react";
import Navbar from "../NavBar";
import Footer from "../Footer";
import "../../styles/IndividualPlayhouse.css";
import { resolveFirestoreImage, useCmsHeroImageReady } from "../../firestoreMedia";

function IndividualPlayhouse({ ...props }) {
	const pending = !!props.heroImagePending;
	const bgUrl = pending
		? null
		: typeof props.heroImage === "string" && props.heroImage
			? props.heroImage
			: resolveFirestoreImage(props.heroImage, props.heroFallback || "");
	const bgReady = useCmsHeroImageReady(bgUrl || "", !pending && !!bgUrl);

	return (
		<div className="ip-page">
			<Navbar />

			{/* ── HERO ── */}
			<div className="sub-hero">
				{!pending && bgUrl && (
					<div
						className={`sub-hero-bg${bgReady ? "" : ""}`}
						style={{
							backgroundImage: `url('${bgUrl}')`,
							opacity: bgReady ? 1 : 0,
							transition: "opacity 0.55s cubic-bezier(0.22, 1, 0.36, 1)",
						}}
					/>
				)}
				<div className="sub-hero-overlay" />
				<div className="sub-hero-content">
					<p className="sub-hero-eyebrow">Our Playhouses</p>
					<h1 className="sub-hero-title">{props.name}</h1>
					<a href="/contact" className="sub-hero-btn">
						<span>Request a Quote</span>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</a>
				</div>
			</div>

			{/* ── DESCRIPTION ── */}
			<div className="ip-description-wrap">
				<p className="ip-description">{props.description}</p>
			</div>

			{/* ── SPECS GRID ── */}
			<div className="ip-specs-section">
				<div className="ip-specs-grid">

					{/* Features */}
					<div className="ip-spec-card">
						<div className="ip-spec-header">Features</div>
						<table className="ip-table">
							<tbody>
								{props.features.map((feature, i) => (
									<tr key={i}>
										<td>{feature.description}</td>
										<td className="ip-dim">{feature.dimensions}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Interior Options */}
					<div className="ip-spec-card">
						<div className="ip-spec-header">Interior Options</div>
						<table className="ip-table">
							<tbody>
								{props.interiorOptions.map((opt, i) => (
									<tr key={i}>
										<td>{opt.description}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Exterior Options */}
					<div className="ip-spec-card">
						<div className="ip-spec-header">Exterior Options</div>
						<table className="ip-table">
							<tbody>
								{props.exteriorOptions.map((opt, i) => (
									<tr key={i}>
										<td>{opt.description}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

				</div>

				{/* Measurements */}
				<div className="ip-measurements">
					<div className="ip-spec-header">Dimensions</div>
					<div className="ip-measurements-list">
						{props.playhouseMeasurements.map((spec, i) => (
							<span key={i} className="ip-measurement-item">{spec}</span>
						))}
					</div>
				</div>
			</div>

			{/* ── CTA BANNER ── */}
			<div className="ip-cta-banner">
				<div className="ip-cta-inner">
					<p className="ip-cta-eyebrow">Ready to Build?</p>
					<h2 className="ip-cta-heading">Let's Make Your Child's Dream Come True</h2>
					<a href="/contact" className="ip-cta-btn">
						<span>Get in Touch</span>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</a>
				</div>
			</div>

			<Footer />
		</div>
	);
}

export default IndividualPlayhouse;
